import { render, staticRenderFns } from "./PCGCGGTT.vue?vue&type=template&id=5450a0e6&scoped=true&"
import script from "./PCGCGGTT.vue?vue&type=script&lang=js&"
export * from "./PCGCGGTT.vue?vue&type=script&lang=js&"
import style0 from "./PCGCGGTT.vue?vue&type=style&index=0&id=5450a0e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5450a0e6",
  null
  
)

export default component.exports